module.exports = __webpack_public_path__ + "static/web-app.bfa4c8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/web-app.jpg
// module id = 839
// module chunks = 34885888655430